export default [
	{
	  path: "/petAdmin/login",
	  name: "PetAdminLogin",
	  meta: {
	    title: "管理系统登录",
	    keepAlive: false,
	    auth: false,
			home: false,
	  },
	  component: () => import("@views/petAdmin/Login.vue")
	},
	{
	  path: "/petAdmin/index",
	  name: "PetAdmin",
	  meta: {
	    title: "设备管理中心",
	    keepAlive: true,
	    auth: true,
			home: false,
	  },
	  component: () => import("@views/petAdmin/Index.vue")
	},
    {
      path: "/petAdmin/deviceList",
      name: "PetAdminDeviceList",
      meta: {
        title: "设备列表",
        keepAlive: true,
        auth: true,
				home: false,
      },
      component: () => import("@views/petAdmin/DeviceList.vue")
    },
		{
		  path: "/petAdmin/orderList/:date",
		  name: "PetAdminOrderList",
		  meta: {
		    title: "订单记录",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/OrderList.vue")
		},
		{
		  path: "/petAdmin/incomeList/:date",
		  name: "PetAdminIncomeList",
		  meta: {
		    title: "收益记录",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/IncomeList.vue")
		},
		{
		  path: "/petAdmin/applyAccounts",
		  name: "PetAdminApplyAccounts",
		  meta: {
		    title: "收益结算",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/ApplyAccounts.vue")
		},
		{
		  path: "/petAdmin/applyTypeList/:date/:type",
		  name: "PetAdminApplyTypeList",
		  meta: {
		    title: "收益明细",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/ApplyTypeList.vue")
		},
		{
		  path: "/petAdmin/financeList",
		  name: "PetAdminFinanceList",
		  meta: {
		    title: "结算记录",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/FinanceList.vue")
		},
		{
		  path: "/petAdmin/financeDetail/:id",
		  name: "PetAdminFinanceDetail",
		  meta: {
		    title: "结算明细",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/FinanceDetail.vue")
		},
		{
		  path: "/petAdmin/faultList",
		  name: "PetAdminFaultList",
		  meta: {
		    title: "故障记录",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/FaultList.vue")
		},
		{
		  path: "/petAdmin/repairsList",
		  name: "PetAdminRepairsList",
		  meta: {
		    title: "报修记录",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/RepairsList.vue")
		},
		{
		  path: "/petAdmin/materialList",
		  name: "PetAdminMaterialList",
		  meta: {
		    title: "物料记录",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/MaterialList.vue")
		},
		{
		  path: "/petAdmin/deviceInfo/:deviceSn",
		  name: "PetAdminDeviceInfo",
		  meta: {
		    title: "设备详情",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/DeviceInfo.vue")
		},
		{
		  path: "/petAdmin/stockConfig/:deviceSn",
		  name: "PetAdminStockConfig",
		  meta: {
		    title: "物料配置",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/StockConfig.vue")
		},
		{
		  path: "/petAdmin/deviceConfig/:deviceSn",
		  name: "PetAdminDeviceConfig",
		  meta: {
		    title: "设备配置",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/DeviceConfig.vue")
		},
		{
		  path: "/petAdmin/notice",
		  name: "PetAdminNotice",
		  meta: {
		    title: "系统公告",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/Notice.vue")
		},
		{
		  path: "/petAdmin/cardConfig",
		  name: "PetAdminCardConfig",
		  meta: {
		    title: "结算银行卡设置",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/CardConfig.vue")
		},
		{
		  path: "/petAdmin/priceConfig/:deviceSn",
		  name: "PetAdminPriceConfig",
		  meta: {
		    title: "价格设置",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/PriceConfig.vue")
		},
		{
		  path: "/petAdmin/temperatureConfig/:deviceSn",
		  name: "PetAdminTemperatureConfig",
		  meta: {
		    title: "温度设置",
		    keepAlive: true,
		    auth: true,
				home: false,
		  },
		  component: () => import("@views/petAdmin/TemperatureConfig.vue")
		},
		
]